import { MagnifyingGlassIcon } from '@radix-ui/react-icons';
import { Link, useParams } from '@tanstack/react-router';
import { EmptyState } from '@/components/states';
import { Button } from '@/components/ui/button';

export function ConfigNotFound() {
  const { configId } = useParams({ strict: false });
  return (
    <EmptyState
      icon={<MagnifyingGlassIcon />}
      title="Config not found"
      description={
        configId ? `There's no config #${configId}. It may have been deleted, or the link is out of date.` : undefined
      }
      action={
        <Button variant="outline" asChild>
          <Link to="/configs">Back to configs</Link>
        </Button>
      }
    />
  );
}
